const GOOGLE_MAP_API_KEY = () => process.env.REACT_APP_GOOGLE_MAPS_KEY;

export default GOOGLE_MAP_API_KEY;
